import React, { useEffect, useState } from 'react';
import { CheckCircle, AlertCircle, Info, X } from 'lucide-react';

export default function Toast({ message, type = 'success', duration = 4000, onClose }) {
  const [visible, setVisible] = useState(false);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    // Trigger enter animation
    requestAnimationFrame(() => setVisible(true));

    const timer = setTimeout(() => {
      setLeaving(true);
      setTimeout(() => {
        setVisible(false);
        onClose?.();
      }, 300);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const icons = {
    success: <CheckCircle size={20} style={{ color: '#10b981', flexShrink: 0 }} />,
    error: <AlertCircle size={20} style={{ color: '#ef4444', flexShrink: 0 }} />,
    info: <Info size={20} style={{ color: '#3b82f6', flexShrink: 0 }} />,
  };

  const borderColors = {
    success: '#10b981',
    error: '#ef4444',
    info: '#3b82f6',
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 20,
        right: 20,
        zIndex: 10000,
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
        padding: '14px 18px',
        background: '#1e293b',
        border: `1px solid ${borderColors[type] || '#3b82f6'}`,
        borderLeft: `4px solid ${borderColors[type] || '#3b82f6'}`,
        borderRadius: 10,
        boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
        maxWidth: 420,
        minWidth: 300,
        color: '#f1f5f9',
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
        fontSize: 14,
        lineHeight: 1.5,
        transform: leaving ? 'translateX(120%)' : 'translateX(0)',
        opacity: leaving ? 0 : 1,
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      }}
    >
      {icons[type] || icons.info}
      <div style={{ flex: 1, whiteSpace: 'pre-line' }}>{message}</div>
      <button
        onClick={() => { setLeaving(true); setTimeout(() => { setVisible(false); onClose?.(); }, 300); }}
        style={{
          background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer',
          padding: 2, borderRadius: 4, display: 'flex', alignItems: 'center',
          flexShrink: 0,
        }}
        onMouseEnter={e => e.currentTarget.style.color = '#f1f5f9'}
        onMouseLeave={e => e.currentTarget.style.color = '#94a3b8'}
      >
        <X size={16} />
      </button>
    </div>
  );
}
